import { VITE_USE_MOCK, VITE_MOCK_API, VITE_QUEUE_MANAGER_API } from 'Constants/appEnvConstants'

export function getQueueManagerBaseUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_QUEUE_MANAGER_API;
}

export default {
  getQueueManagerBaseUrl,
};
